import { render, staticRenderFns } from "./servies.vue?vue&type=template&id=6e05b200&scoped=true"
import script from "./servies.vue?vue&type=script&lang=js"
export * from "./servies.vue?vue&type=script&lang=js"
import style0 from "./servies.vue?vue&type=style&index=0&id=6e05b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05b200",
  null
  
)

export default component.exports